import React from 'react';

import { H3, M, S } from 'components/typography';

import { useLabels } from '../../i18n/useLabels';
import type { TemplateHeaderViewModel } from '../../viewmodels/createTemplateHeaderViewModel';

import styles from './TemplateCustomizationLayout.scss';

type Props = {
  viewModel: TemplateHeaderViewModel;
};

export function TemplateHeader({ viewModel }: Props) {
  const { formatMessage } = useLabels();

  return (
    <div className={styles.header}>
      <H3>{viewModel.name}</H3>
      <M variant="secondary">{formatMessage(viewModel.lastUpdated)}</M>
      <S variant="secondary">{formatMessage(viewModel.summary)}</S>
    </div>
  );
}
